export default __webpack_public_path__ + "static/media/loghi_veneto.6aa635e4.png";